import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import { Wrapper } from './SelectInput.style'
import { icons } from '../../../assets/icons'
import { isEmpty } from 'ramda'

type ChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => void

SelectInput.defaultProps = {
  disabled: false,
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) as PropTypes.Validator<
    string | number
  >,
  placeholder: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  error: PropTypes.bool,
  onChange: PropTypes.func.isRequired as PropTypes.Validator<ChangeEvent>,
  className: PropTypes.string,
  disabled: PropTypes.bool as PropTypes.Validator<boolean>,
}

function SelectInput({
  name,
  value,
  placeholder,
  options,
  onChange,
  error,
  className,
  disabled,
}: InferProps<typeof SelectInput.propTypes>) {
  return (
    <Wrapper className={className || 'empty'} setPlaceholder={isEmpty(value)} error={error}>
      <select
        name={name}
        value={value}
        disabled={disabled}
        onChange={!disabled ? onChange : undefined}
      >
        <option value={placeholder.value} disabled>
          {placeholder.label}
        </option>
        {options &&
          options.map((option, index) => {
            if (option) {
              return (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              )
            } else {
              return <option></option>
            }
          })}
      </select>
      <img alt="dropdown indicator" src={icons.iconDropdown} />
    </Wrapper>
  )
}

export default SelectInput
